// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"5572e8f836b09908ba10","873":"eb3e1dac947ba9769fc5"}[chunkId] + ".js";
};